import { bootstrapApplication } from '@angular/platform-browser';
import { registerLocaleData } from '@angular/common';
import localEsCO from '@angular/common/locales/es-CO';
import { AppComponent } from '@app/app.component';
import { appConfig } from '@app/app.config';
registerLocaleData(localEsCO, 'es-CO');

bootstrapApplication(AppComponent, appConfig)
  .catch((err) => console.error(err));

